'use strict';

class Userbar {
  constructor(userService) {
    this.userService = userService;
  }

  $onInit() {
    this.user = {
      balance: 0
    };
    this.text = 'Ubetalt forbruk';

    this.load();
  }

  load() {
    // console.log('--- user bar');

    this.userService.get()
      .then((resp) => {
        this.user = resp.data;

        if (this.user.balance < 0) {
          this.user.balance *= -1;
          this.text = 'Tilgodehavende';
        }
      });
  }
}

Userbar.$inject = ['userService'];

const userbar = {
  controller: Userbar,
  template: `
    <div class="user-nav hide-for-print">
      <div class="container">
        <div class="row" ng-show="$ctrl.user.userName">
          <div class="large-12 columns">
            <span class="register" id="username"><i class="fa fa-user"></i> <a href="/side/#/konto">{{ $ctrl.user.name }} ({{ $ctrl.user.userName }})</a> [ <a href="/side/#/bytt-konto">Bytt konto</a> ]</span>
            <span>
              <span>{{ $ctrl.text }}: <a href="/side/#/konto/utskrift" ng-class="{ 'label success': $ctrl.user.balance > 0 && $ctrl.text === 'Tilgodehavende', 'label alert': $ctrl.user.balance > 0 && $ctrl.text === 'Ubetalt forbruk' }">{{ $ctrl.user.balance | crowns }}</a></span>
              <span>Forbruk denne m&aring;neden: <a href="/side/#/konto/forbruk">{{ $ctrl.user.notPaid | crowns }}</a></span>
            </span>
          </div>
        </div>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('userbar', userbar);
